<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item"
              >Account</router-link
            >
            <router-link v-if="$parent.offerEnabled" to="/offers" class="item">My Offers</router-link>
            <router-link to="/orders" class="item">Order history</router-link>
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-top">
            <div class="title title-24">
              <b>My Offer</b>
            </div>
            <button v-if="$parent.offerEnabled" class="button" @click="$parent.openSaleSkinModal">
              <span>Sell skins</span>
            </button>
          </div>
          <div
            class="profile-table"
            v-if="$parent.offerEnabled && $parent.offerHistory && $parent.offerHistory.length"
          >
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date</td>
                      <td>Skin name</td>
                      <td>Status</td>
                      <td>Total</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.offerHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.date_time) }}</td>
                      <td>{{ item.title }}</td>
                      <td :class="statusClass(item.status)">
                        <span class="status">{{
                          formatStatus(item.status)
                        }}</span>
                      </td>
                      <td class="desc">
                        <b
                          >{{ item.service_price || item.user_price }}
                          {{ item.currency }}</b
                        >
                      </td>
                      <td>
                        <a
                          class="offer-modal-open desc link"
                          v-if="item.status == 'offer'"
                          @click="openOfferDetails(item)"
                        >
                          <b>View</b>
                        </a>
                        <a
                          class="offer-modal-open desc link"
                          v-if="item.status == 'ready_for_payout'"
                          @click="openAcceptOffer(item)"
                        >
                          <b>Withdraw</b>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "SellOffers",
  methods: {
    formatStatus(status) {
      if (!status) return "";
      return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    statusClass(status) {
      switch (status) {
        case "approved":
        case "ready_for_payout":
          return "green";
        case "declined_by_user":
        case "declined_by_service":
          return "red";
        default:
          return "";
      }
    },
    openOfferDetails(item) {
      this.$parent.openOfferDetailsModal(item);
    },
    openAcceptOffer(item) {
      this.$parent.openAcceptOfferModal(item);
    },
  },
  mounted() {
    if (!this.$parent.offerEnabled) {
      this.$router.push("/profile");
    }
  },
};
</script>
